import React from 'react';
import Reflux from 'reflux';
import { OrderedMap } from 'immutable';
import UserSessionStore from 'flux/stores/UserSessionStore';
import TeamViewStore from 'flux/stores/TeamViewStore';
import EventViewStore from 'flux/stores/EventViewStore';
import EventShowListStore from 'flux/stores/EventShowListStore';
import FullScreenCuesheetStore from 'flux/stores/cuesheet.fullscreen/FullScreenCuesheetStore';
import PageHeader from 'main/components/show/cuesheet.displayView/pageHeader.jsx';
import Footer from 'main/components/show/cuesheet.displayView/footer.jsx';
import DisplayViewRowList from 'main/components/show/cuesheet.displayView/rowList.jsx';
import RouteActions from 'flux/actions/RouteActions';
import FullScreenCuesheetActions from 'flux/actions/cuesheet.fullscreen/FullScreenCuesheetActions';
import classNames from 'classnames';
import ModalActions from 'flux/actions/ModalActions';
import UIRegions from 'shared/constants/UIRegions';
import { displayView as DisplayViewOnboarding } from 'shared/constants/Onboarding';
import FeaturedFullScreenHotKeyHandlers from 'main/components/show/cuesheet.prompter/featuredFullScreenHotKeyHandlers';
import CuesheetTrackingStore from 'flux/stores/cuesheet/CuesheetTrackingStore';
import EventFolderListActions from 'flux/actions/EventFolderListActions';
import EventFolderListStore from 'flux/stores/EventFolderListStore';

const {
  displayViewModal,
  displayViewSelectColumn,
  displayViewSelectShowCaller,
} = DisplayViewOnboarding;

let mouseMoveTimeout;

export default React.createClass({
  displayName: 'DisplayView',

  ...FeaturedFullScreenHotKeyHandlers,

  mixins: [
    Reflux.ListenerMixin,
    Reflux.connect(FullScreenCuesheetStore, 'cuesheet'),
    Reflux.connect(TeamViewStore, 'team'),
    Reflux.connect(EventViewStore, 'event'),
    Reflux.connectFilter(EventShowListStore, 'shows', (state) =>
      state.get('shows'),
    ),
    Reflux.connect(UserSessionStore, 'user'),
    Reflux.connect(CuesheetTrackingStore, 'cuesheetTracking'),
    Reflux.connect(EventFolderListStore, 'folderListStore'),
  ],

  getInitialState() {
    return {
      mouseMovement: false,
    };
  },

  componentDidMount() {
    const { teamId, eventId, showId } = this.props;

    FullScreenCuesheetActions.populate(teamId, eventId, showId);
    if (!this.state.user.getIn(['onboarding', displayViewModal])) {
      ModalActions.show(UIRegions.DisplayViewModal);
    }

    EventFolderListActions.getAllDisplayTypes(teamId, eventId);

    this.listenTo(RouteActions.goToDisplayView, this._populateDisplayView);
    this._enableToggleFullScreenHotKeys();
    window.addEventListener('mousemove', this._showClickableElements);
  },

  /**
   * Remove event listener
   */
  componentWillUnmount() {
    this._disableToggleFullScreenHotKeys();
    window.removeEventListener('mousemove', this._showClickableElements);
  },

  render() {
    const { cuesheet, event, team, user, mouseMovement } = this.state;
    const { folderListStore } = this.state;
    const showsList = folderListStore.get('list');
    if (!showsList) return null;

    const shows = OrderedMap(
      showsList
        .get('items')
        .map((item) => [
          item.getIn(['reference', 'object', '_id']),
          item.getIn(['reference', 'object']),
        ]),
    );

    const { onToggleFullScreenMode } = this.props;

    const { loading } = cuesheet;

    if (loading) return null;

    const onboarding = user.get('onboarding');
    const hasSelectedColumn = onboarding.get(displayViewSelectColumn);
    let hasSelectedShowCaller = onboarding.get(displayViewSelectShowCaller);
    let activeTracking = this.state.cuesheetTracking.get('trackingEnabled');

    if (activeTracking) hasSelectedShowCaller = true;

    const showOnboarding = !hasSelectedColumn || !hasSelectedShowCaller;

    const classes = classNames(
      { 'display-view-onboarding': showOnboarding },
      { 'mouse-move': mouseMovement },
    );

    return (
      <div className={classes}>
        <PageHeader
          showOnboarding={!hasSelectedColumn}
          {...cuesheet}
          event={event.toJS()}
          team={team.toJS()}
          user={user}
          shows={shows}
          onToggleFullScreenMode={onToggleFullScreenMode}
        />
        <DisplayViewRowList
          {...this.props}
          {...cuesheet}
          event={event.toJS()}
        />
        <Footer
          shows={shows}
          {...cuesheet}
          enableTracking={activeTracking}
          showOnboarding={!hasSelectedShowCaller}
        />
      </div>
    );
  },

  _populateDisplayView(params) {
    const { teamId, eventId, showId } = params;

    FullScreenCuesheetActions.populate(teamId, eventId, showId);
  },

  _showClickableElements() {
    this.setState({ mouseMovement: true });
    window.clearTimeout(mouseMoveTimeout);
    mouseMoveTimeout = window.setTimeout(() => {
      this.setState({ mouseMovement: false });
    }, 1000);
  },
});
